const filterObjectByValuesTruthy = (
  obj = {},
  filterCb: Function = () => ({})
) => Object.values(obj).filter(filterCb);

export { filterObjectByValuesTruthy as filterByTruthyValues };
